import { replace } from 'lodash';
import numeral from 'numeral';
import { CURRENCY } from '../constants';

export function fCurrency(number: any) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fCurrencyQAR(number: any) {
  const value = Number(number) || 0;
  return `${CURRENCY} ${Number.isInteger(value) ? value : value.toFixed(2)}`;
}

export function formatPlainPrice(number: any) {
  const value = Number(number) || 0;
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
}

export function fPercent(number: any) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: any) {
  return numeral(number).format();
}

export function fShortenNumber(number: any) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number: any) {
  return numeral(number).format('0.0 b');
}
